import { Dimensions, StyleSheet } from 'react-native';

const width = Dimensions.get('screen').width;
const barWidth = 8.3;
const barNumbers = 9;
const marginLeftValue = 15;
const marginRightValue = 15;
const spaceBetweenBars = (width - marginRightValue - marginLeftValue - barWidth * barNumbers) / 8;

export default StyleSheet.create({
  firstBar: {
    marginLeft: marginLeftValue,
  },
  bars: {
    marginRight: spaceBetweenBars,
    width: barWidth,
    height: 52,
    borderRadius: 5,
  },
  lastBar: {
    marginRight: marginRightValue,
  },
  line: {
    marginTop: 21,
    marginBottom: 41.8,
    width: '100%',
    height: 1,
  },
});
